import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {NavigationComponent} from './pages/navigation.component';
import {MatSidenavModule} from '@angular/material/sidenav';
import {HeaderComponent} from '../header/header.component';
import {FooterComponent} from '../footer/footer.component';
import {RouterModule} from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    MatSidenavModule,
    RouterModule
  ],
  declarations: [
    NavigationComponent,
    HeaderComponent,
    FooterComponent
  ],
  exports: [
    NavigationComponent
  ]
})
export class NavigationModule { }
